<template>
  <div class="container">
    <div v-if="!declined">
      <h3 class="title">Odnaleźliśmy ubezpieczenie na<br/> ten numer PESEL</h3>
      <div class="result">
        <p class="text">
          <span>Nr kontaktowy:</span>
          <span v-if="$auth === 'pesel'">Nr PESEL:</span>
          <span v-if="$auth === 'policy'">Nr polisy:</span>
          <span>Okres obowiązywania:</span>
          <span>Imię:</span>
          <span>Nazwisko:</span>
        </p>
        <p class="text">
          <span>{{userData.PhoneNumber}}</span>
          <span v-if="$auth === 'pesel'">{{pesel}}</span>
          <span v-if="$auth === 'policy'">{{policy}}</span>
          <span>{{isoFormatDate(new Date(Date.parse(verificationResult.EndDate)))}}</span>
          <span>{{verificationResult.FirstName}}</span>
          <span>{{verificationResult.LastName}}</span>
        </p>
      </div>
      <h4 class="subtitle">Czy powyższe dane są prawidłowe?</h4>
      <div class="btn-group">
        <button type="button" class="btn gray" @click="declined = true" v-if="!declined">Nie</button>
        <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler">Tak</button>
      </div>
    </div>
    <div v-else>
      <h3 class="title">Prosimy o kontakt z konsultantem, celem wyjaśnienia nieścisłości.</h3>
      <div class="btn-group three-buttons">
        <a :href="`tel:${$phone}`" class="btn" :style="{ background: $color }" @click="editPesel">Kontakt</a>
        <button type="button" class="btn" :style="{ background: $color }" @click="setHomePage">Menu</button>
        <button type="button" class="btn" :style="{ background: $color }" @click="editPesel">Popraw dane</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: "assistanceStepResult",
  data () {
    return {
      declined: false,
      authOptions: {
        pesel: {
          podaj: 'numer PESEL',
          validator: this.validatePhone
        },
        userName: {
          podaj: 'imię i nazwisko',
          validator: this.validateFullName
        },
        policy: {
          podaj: 'numer polisy',
          validator: this.validatePolicy
        }
      }
    }
  },
  methods: {
    ...mapMutations(['setAssistanceStep', 'setStep', 'setHomePage', 'setPesel', 'setUserData', 'setPolicy']),
    btnHandler () {
      if (this.steps[0].value === 'home') {
        this.setStep({ index: 1, step: { text: 'Wybór usługi', value: 'homeType' }})
        this.setAssistanceStep('homeType')
      } else {
        this.setStep({ index: 1, step: { text: 'Wybór usługi', value: 'medicalType' }})
        this.setAssistanceStep('medicalType')
      }
    },
    isoFormatDate(d) {
      const pad = (n) => {return (n<10? '0' :  '') + n}
      return pad(d.getUTCDate()) + '/' + pad(d.getUTCMonth() + 1) + '/' + d.getUTCFullYear();
    },
    editPesel () {
      // Calling mutation depending on auth method
      this[`set${this.$auth[0].toUpperCase()}${this.$auth.slice(1)}`]('')
      this.setUserData({ PhoneNumber: '' })
      this.setAssistanceStep(this.steps[0].value)
    }
  },
  computed: {
    ...mapState(['steps', 'verificationResult', 'userData', 'pesel', 'policy']),
    auth() {
      return this.authOptions[this.$auth];
    }
  },
  props: {
    activeStep: {}
  },
}
</script>

<style scoped lang="scss">
.text {
  margin-top: 16px;
  color: #454545;
  font-size: 14px;
  line-height: 25px;
  padding-right: 16px;
  span {
    margin-top: 8px;
    display: block;
    white-space: nowrap;
    @media screen and (max-width: 816px) {
      font-size: 12px;
    }
  }
}
.result {
  display: flex;
}
.container {
  width: 400px;
}
.btn {
  margin: 0 8px;
}
.btn-group {
  margin-top: 24px;
  justify-content: space-around;
}
.three-buttons {
  .btn {
    margin: 0 4px;
    padding: 16px 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/Result.vue